import { render, staticRenderFns } from "./printReceipt.vue?vue&type=template&id=1ba42584"
import script from "./printReceipt.vue?vue&type=script&lang=js"
export * from "./printReceipt.vue?vue&type=script&lang=js"
import style0 from "./printReceipt.vue?vue&type=style&index=0&id=1ba42584&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports